<template>
  <div>
    <HeadBar /><!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav /><!-- 顶部导航-->
    <div class="lab">
      <div class="lab-inner">
        <div class="lab-path">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'labList' }"
              >实验室列表</el-breadcrumb-item
            >
            <el-breadcrumb-item>详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <Info
          :detail="detail"
          :businessLicence="businessLicence"
          :qualifications="qualifications"
        />
        <div class="info-other">
          <h3>检测业务</h3>
          <div class="info-other-text">{{ detail.laboratoryCheckInfo }}</div>
          <h3>特色检测能力</h3>
          <div class="info-other-text">{{ detail.specialAbility }}</div>
        </div>
        <Introduce :detail="detail" :banners="banners" />
        <Devices />
        <CheckProducts />
      </div>
    </div>
    <FootBar class="footer" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { labDetail } from "@/api/lab";
import Devices from "./components/Devices";
import Introduce from "./components/Introduce";
import CheckProducts from "./components/CheckProducts";
import Info from "./components/Info";
export default {
  components: {
    Devices,
    CheckProducts,
    Introduce,
    Info,
  },
  data() {
    return {
      activeName: "first",
      detail: {},
      qualifications: [],
      businessLicence: [],
      banners: [],
      loading: false,
      mainId: null,
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  created() {
    this.mainId = this.$route.query.id;
    this.getDetail();
  },
  methods: {
    async getDetail() {
      try {
        this.loading = true;
        const data = await this.$axios.get(labDetail, {
          laboratoryId: this.mainId,
        });
        this.loading = false;
        this.detail = data;
        const { checkQualification, laboratoryBanner, businessLicence } = data;
        if (checkQualification) {
          const arr = checkQualification.split(";");
          this.qualifications = arr.reduce(
            (accumulator, currentValue, currentIndex) => {
              if (currentIndex % 2 === 0) {
                accumulator.push([currentValue]);
              } else {
                accumulator[accumulator.length - 1].push(currentValue);
              }
              return accumulator;
            },
            []
          );
        }
        if (laboratoryBanner) {
          this.banners = laboratoryBanner.split(";");
        }
        if (businessLicence) {
          this.businessLicence = businessLicence.split(";");
        }
      } catch (e) {
        this.$message.error("服务异常，请稍后再试");
      }
    },
    // 发布需求
    toRelease() {
      this.$jump.push({
        name: "releaseReq",
        query: { relationLabId: this.mainId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
$item-h: 140px;
.lab {
  padding-top: 20px;
  &-inner {
    width: $max-width;
    margin: 0 auto;
    padding-bottom: 30px;
  }
  &-path {
    margin-bottom: 20px;
  }
  background: url($oss-url + "home/bg/bg-4.png") no-repeat 0 0 / 100% 1000px,
    url($oss-url + "home/bg/bg-5.png") no-repeat 0 1000px / 100% 1000px,
    url($oss-url + "home/bg/bg-4.png") no-repeat 0 2000px / 100% 1000px;
  background-color: rgb(248, 251, 255);
}
.info-other {
  background: #fff;
  padding: 20px 20px 0 20px;
  margin-top: 20px;
  h3 {
    font-size: 16px;
    color: #333;
    padding-bottom: 10px;
  }
  &-text {
    line-height: 24px;
    font-size: 14px;
    color: #333;
    padding-bottom: 20px;
  }
}

.footer {
  padding-top: 0;
}
::v-deep .section {
  padding-top: 80px;
  &-title {
    font-size: 32px;
    color: #333;
    text-align: center;
    font-weight: bold;
    span {
      position: relative;
    }
  }
  &-title span::after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: -16px;
    margin-left: 50%;
    width: 32px;
    height: 2px;
    background: #002769;
  }
  &-tips {
    padding-top: 20px;
    text-align: center;
    font-size: 14px;
    color: var(--dark-black);
  }
  &-content {
    padding-top: 40px;
  }
}
</style>
